export default __webpack_public_path__ + "static/xr_glasses_m-e3cdc9e48989e906c6ed28d67be0c598.png";